import { useState } from "react";
import { useSelectFormStore, useForm, useAdminStore } from "../../../hooks";
import { useAuthStore } from "../../../auth/hooks";
import {
  InputForm,
  SelectForm,
  LoadingData,
  ErrorMessage,
  SuccessMessage,
} from "../../ui";
import { useFormMessages } from "../../hooks";

const formValidations = {
  document: [
    (value) => value.length > 7,
    "El documento debe ser mayor a 7 caracteres",
  ],
  documentTypeId: [
    (value) => value.length > 0,
    "Selecciona un tipo de documento",
  ],
  firstName: [(value) => value.length > 0, "El nombre no puede ser vacio"],
  lastName: [(value) => value.length > 0, "El apellido no puede ser vacio"],
  phoneNumber: [
    (value) => value.length > 9,
    "El numero de celular debe contener más de 9 digitos",
  ],
  countryPhoneId: [
    (value) => value.length > 0,
    "Selecciona un pais del celular",
  ],
  country: [(value) => value.length > 0, "El país no puede ser vacio"],
  department: [
    (value) => value.length > 0,
    "El departamento no puede ser vacio",
  ],
  city: [(value) => value.length > 0, "La ciudad no puede ser vacia"],
  address: [(value) => value.length > 0, "La dirección no puede ser vacia"],
  genderId: [(value) => value.length > 0, "Selecciona un género"],
  ipsId: [(value) => value.length > 0, "Selecciona una ips"],
};

export const EditSecretaryProfile = () => {
  // Datos de hooks ----------------------------------------//
  const {
    // Props
    message,
    isLoading,

    // Methods
    startUpdateAdmin,
  } = useAdminStore();

  const {
    isLoading: isLoadingForm,
    documentTypes,
    countryPhones,
    genders,
    ipss,
  } = useSelectFormStore(["documentTypes", "countryPhones", "genders", "ipss"]);

  const { user } = useAuthStore();

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);
  const [formData, setFormData] = useState(() => ({
    document: user.document,
    documentTypeId: user.documentType.id,
    firstName: user.firstName,
    lastName: user.lastName,
    phoneNumber: user.phoneNumber,
    countryPhoneId: user.countryPhone.id,
    country: user.country,
    department: user.department,
    city: user.city,
    address: user.address,
    genderId: user.gender.id,
    ipsId: user.ips.id,
  }));

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid } = useForm(
    formData,
    formValidations
  );

  const {
    setFormSubmitted,
    showErrorMessage,
    showSuccessMessage,
    messageText,
  } = useFormMessages({
    message,
    setValidateForm,
  });

  const {
    document,
    documentTypeId,
    firstName,
    lastName,
    phoneNumber,
    countryPhoneId,
    country,
    department,
    city,
    address,
    genderId,
    ipsId,
  } = formState;

  const {
    documentValid,
    documentTypeIdValid,
    firstNameValid,
    lastNameValid,
    phoneNumberValid,
    countryPhoneIdValid,
    countryValid,
    departmentValid,
    cityValid,
    addressValid,
    genderIdValid,
    ipsIdValid,
  } = formValidation;

  // Funciones ---------------------------------------------//
  const onUpdate = (event) => {
    event.preventDefault();
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startUpdateAdmin(formState);
    }
  };

  // Efectos -----------------------------------------------//

  return (
    <div className="rounded shadow mt-4">
      <div className="p-4 border-bottom">
        <h6 className="mb-0">Información personal:</h6>
      </div>
      <div className="p-4">
        <form onSubmit={onUpdate}>
          <div className="row g-3">
            {/* Formulario estatico */}
            <>
              <div className="col-md-6">
                <InputForm
                  label={"Documento"}
                  type={"text"}
                  placeholder={"Documento"}
                  validation={documentValid}
                  submit={validateForm}
                  name={"document"}
                  value={document}
                  onInputChange={onInputChange}
                />
              </div>
              <div className="col-md-6">
                <SelectForm
                  label={"Tipo de documento"}
                  options={documentTypes}
                  labelKey={"description"}
                  validation={documentTypeIdValid}
                  submit={validateForm}
                  name={"documentTypeId"}
                  value={documentTypeId}
                  onInputChange={onInputChange}
                />
              </div>
              <div className="col-md-6">
                <InputForm
                  label={"Nombre"}
                  type={"text"}
                  placeholder={"Nombre"}
                  validation={firstNameValid}
                  submit={validateForm}
                  name={"firstName"}
                  value={firstName}
                  onInputChange={onInputChange}
                />
              </div>
              <div className="col-md-6">
                <InputForm
                  label={"Apellido"}
                  type={"text"}
                  placeholder={"Apellido"}
                  validation={lastNameValid}
                  submit={validateForm}
                  name={"lastName"}
                  value={lastName}
                  onInputChange={onInputChange}
                />
              </div>
              <div className="col-md-6">
                <InputForm
                  label={"No. celular"}
                  type={"text"}
                  placeholder={"No. celular"}
                  validation={phoneNumberValid}
                  submit={validateForm}
                  name={"phoneNumber"}
                  value={phoneNumber}
                  onInputChange={onInputChange}
                />
              </div>
              <div className="col-md-6">
                <SelectForm
                  label={"País del celular"}
                  options={countryPhones}
                  labelKey={"name"}
                  validation={countryPhoneIdValid}
                  submit={validateForm}
                  name={"countryPhoneId"}
                  value={countryPhoneId}
                  onInputChange={onInputChange}
                />
              </div>
              <div className="col-md-12">
                <hr />
                <label className="form-label">Dirección</label>
              </div>
              <div className="col-md-6">
                <InputForm
                  label={"Pais"}
                  type={"text"}
                  placeholder={"Pais"}
                  validation={countryValid}
                  submit={validateForm}
                  name={"country"}
                  value={country}
                  onInputChange={onInputChange}
                />
              </div>
              <div className="col-md-6">
                <InputForm
                  label={"Departamento"}
                  type={"text"}
                  placeholder={"Departamento"}
                  validation={departmentValid}
                  submit={validateForm}
                  name={"department"}
                  value={department}
                  onInputChange={onInputChange}
                />
              </div>
              <div className="col-md-6">
                <InputForm
                  label={"Ciudad"}
                  type={"text"}
                  placeholder={"Ciudad"}
                  validation={cityValid}
                  submit={validateForm}
                  name={"city"}
                  value={city}
                  onInputChange={onInputChange}
                />
              </div>
              <div className="col-md-6">
                <InputForm
                  label={"Dirección"}
                  type={"text"}
                  placeholder={"Dirección"}
                  validation={addressValid}
                  submit={validateForm}
                  name={"address"}
                  value={address}
                  onInputChange={onInputChange}
                />
              </div>
              <div className="col-md-12">
                <hr />
              </div>
              <div className="col-md-6">
                <SelectForm
                  label={"Genero"}
                  options={genders}
                  labelKey={"name"}
                  validation={genderIdValid}
                  submit={validateForm}
                  name={"genderId"}
                  value={genderId}
                  onInputChange={onInputChange}
                />
              </div>
              <div className="col-md-6">
                <SelectForm
                  label={"Ips"}
                  options={ipss}
                  labelKey={"name"}
                  validation={ipsIdValid}
                  submit={validateForm}
                  name={"ipsId"}
                  value={ipsId}
                  onInputChange={onInputChange}
                />
              </div>
            </>

            {/* Mensajes */}
            <>
              {(isLoading || isLoadingForm) && (
                <div className="col-md-12">
                  <LoadingData />
                </div>
              )}
              {showErrorMessage && (
                <div className="col-md-12">
                  <ErrorMessage>{messageText}</ErrorMessage>
                </div>
              )}
              {showSuccessMessage && (
                <div className="col-md-12">
                  <SuccessMessage>{messageText}</SuccessMessage>
                </div>
              )}
            </>

            <div className="col-md-12">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isLoading || isLoadingForm}
              >
                Guardar cambios
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
